"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eq = void 0;
/** @internal */
var eq = function (array1, array2) {
    return array1.length === array2.length && array1.every(function (v, i) { return v === array2[i]; });
};
exports.eq = eq;
